import { Clipboard } from '@angular/cdk/clipboard';
import * as i0 from '@angular/core';
import { inject, Component, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';
import { NgDocTooltipDirective, NgDocButtonIconComponent, NgDocSmoothResizeComponent } from '@ng-doc/ui-kit';
const _c0 = ["*"];
function NgDocCopyButtonComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-doc-smooth-resize", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("trigger", ctx_r1.tooltipText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.tooltipText, " ");
  }
}
let NgDocCopyButtonComponent = /*#__PURE__*/(() => {
  class NgDocCopyButtonComponent {
    constructor() {
      this.tooltipText = '';
      this.clipboard = inject(Clipboard);
    }
    copy() {
      this.clipboard.copy(this.text);
      this.tooltip.show();
    }
    static {
      this.ɵfac = function NgDocCopyButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocCopyButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocCopyButtonComponent,
        selectors: [["ng-doc-copy-button"]],
        viewQuery: function NgDocCopyButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(NgDocTooltipDirective, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
          }
        },
        inputs: {
          text: "text"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 2,
        consts: [["tooltipContent", ""], ["ng-doc-button-icon", "", 3, "click", "mouseenter", "rounded", "ngDocTooltip"], [3, "trigger"]],
        template: function NgDocCopyButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 1);
            i0.ɵɵlistener("click", function NgDocCopyButtonComponent_Template_button_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              ctx.copy();
              return i0.ɵɵresetView(ctx.tooltipText = "Copied!");
            })("mouseenter", function NgDocCopyButtonComponent_Template_button_mouseenter_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.tooltipText = "Copy to clipboard");
            });
            i0.ɵɵtemplate(1, NgDocCopyButtonComponent_ng_template_1_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const tooltipContent_r3 = i0.ɵɵreference(2);
            i0.ɵɵproperty("rounded", false)("ngDocTooltip", tooltipContent_r3);
          }
        },
        dependencies: [NgDocButtonIconComponent, NgDocTooltipDirective, NgDocSmoothResizeComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NgDocCopyButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocCopyButtonComponent };
